// extracted by mini-css-extract-plugin
export default {"container":"container___F-Aiu","gameName":"gameName___317qq","logo":"logo___1ehuO"};